import type { FC, ReactElement } from 'react';

import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '../../store/slices/config/selectors';

import { BetLimits } from './betlimits/BetLimits';
import { BetLimitsTableConnected } from './betlimits/betLimitsTable/BetLimitsTableConnected';
import { LimitConnected } from './betlimits/limit/LimitConnected';
import type { BetLimitData } from './types';

interface BetLimitsConnectedProps {
  additionalInformation?: ReactElement;
  betLimitData?: BetLimitData[];
  footNotes?: ReactElement[];
}

export const BetLimitsConnected: FC<BetLimitsConnectedProps> = ({
  betLimitData,
  footNotes,
  additionalInformation,
}): ReactElement => {
  const tableBetLimits = useConfigSlice.tableBetLimits();
  const tableName = useConfigSlice.tableName() ?? '';

  return (
    <BetLimits
      tableName={<L10nText tk={tableName} />}
      tableLimit={<LimitConnected limits={[tableBetLimits?.min ?? 0, tableBetLimits?.max ?? 0]} />}
      betLimitTable={betLimitData ? <BetLimitsTableConnected betLimitData={betLimitData} /> : null}
      additionalInformation={additionalInformation}
      footNotes={footNotes}
    />
  );
};
